import {
    boolFormatter,
    commaSeparatedListFormatter,
    dmarcPolicyIconRenderer,
    dateFormatter,
    numberFormatter,
    rateFormatter,
    stringFormatter
} from '../table-utils';

const boolColumn = {
    valueFormatter: boolFormatter,
};

const checkboxColumn = {
    cellClass: 'no-left-padding',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    headerClass: 'no-left-padding',
};

const commaSeparatedListColumn = {
    valueFormatter: commaSeparatedListFormatter
};

const dateColumn = {
    valueFormatter: dateFormatter
};

const numberColumn = {
    aggFunc: 'sum',
    enableValue: true,
    valueFormatter: numberFormatter
};

const policyIconColumn = {
    cellRendererFramework: dmarcPolicyIconRenderer
};

const rateColumn = {
    enableValue: true,
    valueFormatter: rateFormatter
};

const rightAlignColumn = {
    cellStyle: {
        textAlign: 'right'
    },
    headerClass: 'header-align-right',
};

const sortAscDescColumn = {
    sortingOrder: ['asc', 'desc']
};

const stringColumn = {
    valueFormatter: stringFormatter
};

/* Don't freeze this default export in case additional column types 
/* are defined at the table-level (we merge custom options over the default options)
 */
export default Object( {
    boolColumn,
    checkboxColumn,
    commaSeparatedListColumn,
    dateColumn,
    numberColumn,
    policyIconColumn,
    rateColumn,
    rightAlignColumn,
    sortAscDescColumn,
    stringColumn,
} );
